export default __webpack_public_path__ + "static/astungkara-3b38470cadfacf0514f83477cfc95ca1.png";